import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexScoringErrors extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { companyResponses, currentContractorId } = this.props;

    return (
      <Card body>
        <h1 className="large">Calibration Tests</h1>
        <p>
          These tests are placed randomly in the queue. We use these to evaluate
          the team{"'"}s performance.
        </p>
        {companyResponses.map(r => {
          return (
            <div key={r.company.id}>
              <h3>{r.company.name}</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>Date Taken</th>
                    <th>Wrong Label</th>
                    <th>Did Not Label</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {r.responses.map(res => {
                    return (
                      <tr key={res.qa_quiz_id}>
                        <td>{res.created_at_string}</td>
                        <td>{res.fp_percent_pretty}</td>
                        <td>{res.fn_percent_pretty}</td>
                        <td>
                          <a
                            href={
                              "contractor_users/" +
                              currentContractorId +
                              "/qa_quiz/" +
                              res.qa_quiz_id
                            }
                          >
                            Link
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </Card>
    );
  }
}
